import io from 'socket.io-client';

const env = 'prod';

var sock = io(env == 'dev' ? 'http://localhost:8090' : 'https://streaming.sliderconnect.com', {
    secure: env == 'dev' ? false : true,
    autoConnect: false,
});

export default sock;